import React from 'react';
import { KPIData } from '../../interfaces/types';
import { formatNumber, formatCurrencyAbbreviated } from '../../utils/utils';

interface KPICardsProps {
  kpis: KPIData;
}

export const KPICards: React.FC<KPICardsProps> = ({ kpis }) => {
  return (
    <section className="cost-centers-overview-kpis">
      <div className="cost-centers-overview-kpis__grid">
        <div className="cost-centers-overview-kpi-card">
          <span>Cost centers</span>
          <strong title={kpis.totalCostCenters.toLocaleString()}>
            {formatNumber(kpis.totalCostCenters)}
          </strong>
        </div>
        <div className="cost-centers-overview-kpi-card">
          <span>Users</span>
          <strong title={kpis.totalUsers.toLocaleString()}>
            {formatNumber(kpis.totalUsers)}
          </strong>
        </div>
        <div className="cost-centers-overview-kpi-card">
          <span>Shared pool AIC</span>
          <strong title={kpis.totalSharedPoolAIC.toLocaleString()}>
            {formatNumber(kpis.totalSharedPoolAIC)}
          </strong>
        </div>
        <div className="cost-centers-overview-kpi-card">
          <span>Utilized AIC</span>
          <strong title={kpis.totalUtilizedAIC.toLocaleString()}>
            {formatNumber(kpis.totalUtilizedAIC)}
          </strong>
        </div>
        <div className="cost-centers-overview-kpi-card cost-centers-overview-kpi-card--accent">
          <span>Actual spend ($)</span>
          <strong title={`$${kpis.totalActualSpend.toLocaleString()}`}>
            {formatCurrencyAbbreviated(kpis.totalActualSpend)}
          </strong>
        </div>
        <div className="cost-centers-overview-kpi-card cost-centers-overview-kpi-card--accent">
          <span>Overused AIC</span>
          <strong title={kpis.overusedCostCenters.toLocaleString()}>
            {formatNumber(kpis.overusedCostCenters)}
          </strong>
        </div>
        <div className="cost-centers-overview-kpi-card cost-centers-overview-kpi-card--accent">
          <span>Excess spend ($)</span>
          <strong title={`$${kpis.totalExcessSpend.toLocaleString()}`}>
            {formatCurrencyAbbreviated(kpis.totalExcessSpend)}
          </strong>
        </div>
      </div>
    </section>
  );
};
